export default "__VITE_ASSET__Cbs1Jz40__"